module.exports = __webpack_public_path__ + "img/album12_02.6fc036ce.jpg";